import { render, staticRenderFns } from "./UserBaseInfo.vue?vue&type=template&id=fd6cd034&scoped=true&"
import script from "./UserBaseInfo.vue?vue&type=script&lang=js&"
export * from "./UserBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./UserBaseInfo.vue?vue&type=style&index=0&id=fd6cd034&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6cd034",
  null
  
)

export default component.exports